import { render, staticRenderFns } from "./videoAddEDit.vue?vue&type=template&id=c9fdd2e8&scoped=true&"
import script from "./videoAddEDit.vue?vue&type=script&lang=js&"
export * from "./videoAddEDit.vue?vue&type=script&lang=js&"
import style0 from "./videoAddEDit.vue?vue&type=style&index=0&id=c9fdd2e8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9fdd2e8",
  null
  
)

export default component.exports